module.exports = __webpack_public_path__ + "static/story3-02-3815x1355-ca4b659509e082bc5c1eed078fed798b.jpg";